module.exports = __webpack_public_path__ + "static/media/logo_icon.db9660ff.svg";